import cloneDeep from 'lodash/cloneDeep'

export interface Filter {
    type: string
    properties: {
        _rectangle_in?: {
            _x0: number
            _y0: number
            _x1: number
            _y1: number
        }
        _rectangle_out?: {
            _x0: number
            _y0: number
            _x1: number
            _y1: number
        }
        _rectangle_in_out?: {
            _x0: number
            _y0: number
            _x1: number
            _y1: number
        }
    }
}

export function importTransformation(filter: Filter, imageWidth: number, imageHeight: number) {
    const normalizedFilter = cloneDeep(filter)

    if (normalizedFilter.type === 'FilterInvalidTrajectory_Double') {
        if (filter.properties._rectangle_in_out) {
            const rectInOut = filter.properties._rectangle_in_out
            normalizedFilter.properties._rectangle_in_out = {
                ...rectInOut,
                _x0: (rectInOut._x0 / imageWidth) * 750,
                _x1: (rectInOut._x1 / imageWidth) * 750,
                _y0: (rectInOut._y0 / imageHeight) * (750 * (imageHeight / imageWidth)),
                _y1: (rectInOut._y1 / imageHeight) * (750 * (imageHeight / imageWidth))
            }
        }
    } else {
        if (filter.properties._rectangle_in) {
            const rectIn = filter.properties._rectangle_in
            normalizedFilter.properties._rectangle_in = {
                ...rectIn,
                _x0: (rectIn._x0 / imageWidth) * 750,
                _x1: (rectIn._x1 / imageWidth) * 750,
                _y0: (rectIn._y0 / imageHeight) * (750 * (imageHeight / imageWidth)),
                _y1: (rectIn._y1 / imageHeight) * (750 * (imageHeight / imageWidth))
            }
        }

        if (filter.properties._rectangle_out) {
            const rectOut = filter.properties._rectangle_out
            normalizedFilter.properties._rectangle_out = {
                ...rectOut,
                _x0: (rectOut._x0 / imageWidth) * 750,
                _x1: (rectOut._x1 / imageWidth) * 750,
                _y0: (rectOut._y0 / imageHeight) * (750 * (imageHeight / imageWidth)),
                _y1: (rectOut._y1 / imageHeight) * (750 * (imageHeight / imageWidth))
            }
        }
    }

    return normalizedFilter
}
